module.exports = __webpack_public_path__ + "img/valerie stephens.7460fef9.jpg";